<!--
 * @created on 2018/11/13
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <div class="container">
        <div class="success-logo">
            <img src="../assets/composeSuccess/bg.png">
        </div>

        <template v-if="$env.isTravelCatApp">
            <div class="success-title">
                <div class="check-icon">
                    <svg-icon icon-class="checkmark" class-name="icon"></svg-icon>
                </div>
                您拟发布的内容已提交审核
            </div>

            <div class="success-desc">
                为营造纯净的结伴环境，我们会对每篇拟发布内容进行审核。
            </div>

            <div class="success-desc">
                审核结果将在24小时内以服务消息的形式发送给您，您还可以在
                <b class="my-poster" @click="handleToMyPublish">我的-我发布的</b>
                页面查看进度，请您耐心等待！
            </div>

            <div class="to-index-btn" @click="handleBackToHome">返回首页</div>
        </template>

        <template v-else>
            <div class="success-title">
                <div class="check-icon">
                    <svg-icon icon-class="checkmark" class-name="icon"></svg-icon>
                </div>
                您拟发布的内容已提交审核
            </div>

            <div class="success-desc">
                关注“<em>旅喵结伴</em>”官方公众号，我们将在24小时内将审核结果以服务消息的形式发送给您，您还可以在
                <b class="my-poster" @click="handleToMyPublish">我的-我发布的</b>
                页面查看进度哦~
            </div>

            <div class="to-index-btn" @click="handleBackToHome">点击关注</div>
        </template>
    </div>
</template>

<style scoped lang="scss">
@import "../style/config";
@import "../style/function";

.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    overflow: hidden;
}

.success-logo {
    width: px2rem(602 /2);
    height: px2rem(440 /2);
    margin-bottom: px2rem(32);

    img {
        display: block;
        width: 100%;
    }
}

.success-title {
    display: flex;
    align-items: center;
    color: #333;
    font-size: px2rem(32);
    margin-bottom: px2rem(36);
    font-weight: bold;
}

.check-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $btnColor;
    width: px2rem(32);
    height: px2rem(32);
    border-radius: 100%;
    color: #fff;
    margin-right: px2rem(10);

    .icon {
        width: 50%;
    }
}

.success-desc {
    width: px2rem(636);
    line-height: 1.5;
    padding-bottom: 1em;
    color: #666;
    font-size: px2rem(28);
    font-weight: bold;

    em {
        font-style: normal;
        color: $btnColor;
    }
}

.my-poster {
    color: $btnColor;
}

.to-index-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: px2rem(76);
    width: px2rem(280);
    height: px2rem(76);
    font-size: px2rem(32);
    margin-top: px2rem(20);
    color: #fff;
    background: $btnColor;
}
</style>

<script>
import { backToHome } from "../nativeApi";

export default {
    name: "ComposeSuccess",
    data() {
        return {};
    },
    methods: {
        handleToMyPublish() {
            this.$router.replace({
                name: "myPublish",
                params: {
                    id: this.$store.getters.userInfo.userId
                }
            });
        },

        handleBackToHome() {
            // app 需要跳原声首页
            if (this.$env.isTravelCatApp) {
                backToHome();
            } else {
                window.location.href =
                    "http://mp.weixin.qq.com/s?__biz=MzU4MDgxNzg4Mg==&mid=100000010&idx=1&sn=0f5f523f90ab68b0b6e2b23faf8dfe6a&chksm=7d5047bf4a27cea990eb5b1772c09ffc74fe0cd3aa5a1bb723afd79099846a6d1e74b29c0256#rd";
            }
        }
    }
};
</script>
